import {Action} from '@ngrx/store';
import {  IAppointment, IAppointmentSummary } from '@signal/asp-data-commons';
import { IAvailability } from '@signal/asp-data-commons/lib/interfaces/availability';
import { IDashboardDetails } from './schedule-dashboard.reducer';

export enum ScheduleDashboardActionTypes {
    LOAD_SCHEDULE_DASHBOARD_SLOT = '[Dashboard Calendar] Load schedule dashboard slot',
    LOAD_SCHEDULE_DASHBOARD_SLOT_SUCCESS = '[Dashboard Calendar] Load schedule dashboard slot success',
    LOAD_SCHEDULE_DASHBOARD_SLOT_FAILURE = '[Dashboard Calendar] Load schedule dashboard slot failure',
    LOAD_SCHEDULE_DASHBOARD_APPOINTMENTS = '[Dashboard Calendar] Load schedule dashboard appointment',
    LOAD_SCHEDULE_DASHBOARD_APPOINTMENTS_REFRESH = '[Dashboard Calendar] Load schedule dashboard appointment refresh',
    LOAD_SCHEDULE_DASHBOARD_APPOINTMENTS_SUCCESS = '[Dashboard Calendar] Load schedule dashboard appointment success',
    LOAD_SCHEDULE_DASHBOARD_APPOINTMENTS_FAILURE = '[Dashboard Calendar] Load schedule dashboard appointment failure',
    LOAD_SCHEDULE_DASHBOARD_DETAILS = '[Dashboard Calendar] Load schedule dashboard details',
    LOAD_SCHEDULE_DASHBOARD_DETAILS_SUCCESS = '[Dashboard Calendar] Load schedule dashboard details success',
    LOAD_SCHEDULE_DASHBOARD_DETAILS_FAILURE = '[Dashboard Calendar] Load schedule dashboard details failure',
    UPDATE_SCHEDULE_DASHBOARD_DETAILS = '[Dashboard Calendar] Update schedule dashboard details',
    UPDATE_SCHEDULE_DASHBOARD_DETAILS_SUCCESS = '[Dashboard Calendar] Update schedule dashboard details success',
    UPDATE_SCHEDULE_DASHBOARD_DETAILS_FAILURE = '[Dashboard Calendar] Update schedule dashboard details failure',
    UPDATE_APPOINTMENT_TIME = '[Dashboard Calendar] Update appointment time slot',
    UPDATE_APPOINTMENT_TIME_SUCCESS = '[Dashboard Calendar] Update appointment time slot success',
    UPDATE_APPOINTMENT_TIME_FAILURE = '[Dashboard Calendar] Update appointment time slot failure',
    CLEAR_SCHEDULE_DASHBOARD_SLOT = '[Dashboard Calendar] Clear schedule dashboard slot',
}

export class LoadScheduleDashboardSlot implements Action {
    readonly type = ScheduleDashboardActionTypes.LOAD_SCHEDULE_DASHBOARD_SLOT;
    constructor(public payload: {department: string, startDate: string, endDate: string}){}
}

export class LoadScheduleDashboardSlotSuccess implements Action {
    readonly type = ScheduleDashboardActionTypes.LOAD_SCHEDULE_DASHBOARD_SLOT_SUCCESS;
  
    constructor(public payload: { availabilityData: IAvailability, department: string }) {
    }
}

export class LoadScheduleDashboardSlotFailure implements Action {
    readonly type = ScheduleDashboardActionTypes.LOAD_SCHEDULE_DASHBOARD_SLOT_FAILURE;
  
    constructor(public payload: { error: string, department: string }) {
    }
  }

  export class UpdateScheduleDashboardDetail implements Action {
    readonly type = ScheduleDashboardActionTypes.UPDATE_SCHEDULE_DASHBOARD_DETAILS;
    constructor(public payload: {department: string, dashboardDetails: IDashboardDetails}){}
}

export class UpdateScheduleDashboardDetailSuccess implements Action {
    readonly type = ScheduleDashboardActionTypes.UPDATE_SCHEDULE_DASHBOARD_DETAILS_SUCCESS;
  
    constructor(public payload: { data: IDashboardDetails, department: string }) {
    }
}

export class UpdateScheduleDashboardDetailFailure implements Action {
    readonly type = ScheduleDashboardActionTypes.UPDATE_SCHEDULE_DASHBOARD_DETAILS_FAILURE;
  
    constructor(public payload: { error: string, department: string }) {
    }
  }


  export class LoadScheduleDashboardAppointments implements Action {
    readonly type = ScheduleDashboardActionTypes.LOAD_SCHEDULE_DASHBOARD_APPOINTMENTS;
    constructor(public payload: {department: string, startDate: string, endDate: string, filters: any, viewMode: string}){}
}

export class LoadScheduleDashboardAppointmentsRefresh implements Action {
    readonly type = ScheduleDashboardActionTypes.LOAD_SCHEDULE_DASHBOARD_APPOINTMENTS_REFRESH;
    constructor(public payload: {department: string, startDate: string, endDate: string, filters: any, viewMode: string}){}
}

export class LoadScheduleDashboardAppointmentsSuccess implements Action {
    readonly type = ScheduleDashboardActionTypes.LOAD_SCHEDULE_DASHBOARD_APPOINTMENTS_SUCCESS;
  
    constructor(public payload: { appointmentSummary: IAppointmentSummary[], department: string }) {
    }
}

export class LoadScheduleDashboardAppointmentsFailure implements Action {
    readonly type = ScheduleDashboardActionTypes.LOAD_SCHEDULE_DASHBOARD_APPOINTMENTS_FAILURE;
  
    constructor(public payload: { error: string, department: string }) {
    }
  }

export class UpdateAppointmentTime implements Action {
    readonly type = ScheduleDashboardActionTypes.UPDATE_APPOINTMENT_TIME;

    constructor(public payload: {appointment: IAppointment, newTimeSlot: string}){}
}

export class UpdateAppointmentTimeSuccess implements Action {
    readonly type = ScheduleDashboardActionTypes.UPDATE_APPOINTMENT_TIME_SUCCESS;

    constructor(public payload: {appointment: IAppointment}){}
}

export class UpdateAppointmentTimeFailure implements Action {
    readonly type = ScheduleDashboardActionTypes.UPDATE_APPOINTMENT_TIME_FAILURE;

    constructor(public payload: { error: string}){}
}

export class ClearScheduleDashboardSlot implements Action {
    readonly type = ScheduleDashboardActionTypes.CLEAR_SCHEDULE_DASHBOARD_SLOT;
    constructor(public payload: { department: string}){}
}

  export type ScheduleDashboardActions =
  LoadScheduleDashboardSlot 
  | LoadScheduleDashboardSlotSuccess
  | LoadScheduleDashboardSlotFailure
  | LoadScheduleDashboardAppointments
  | LoadScheduleDashboardAppointmentsSuccess
  | LoadScheduleDashboardAppointmentsFailure
  | LoadScheduleDashboardAppointmentsRefresh
  | UpdateScheduleDashboardDetail
  | UpdateScheduleDashboardDetailFailure
  | UpdateScheduleDashboardDetailSuccess
  | UpdateAppointmentTime
  | UpdateAppointmentTimeSuccess
  | UpdateAppointmentTimeFailure
  | ClearScheduleDashboardSlot;
